import { Link } from "react-router-dom";
import { Menu, Settings, BookOpen } from "lucide-react";
import SearchBar from "./SearchBar";

export default function TopBar({ onOpenSidebar }) {
    return (
        <header className="h-16 flex-shrink-0 border-b border-slate-200 bg-white/80 backdrop-blur-xl px-4 sm:px-6 flex items-center gap-3 sm:gap-6 z-10">
            <button
                data-testid="topbar-open-sidebar"
                onClick={onOpenSidebar}
                className="md:hidden p-2 rounded hover:bg-slate-100"
            >
                <Menu className="h-5 w-5 text-medical-800" />
            </button>
            <Link to="/" className="hidden md:flex items-center gap-2 text-medical-900 hover:text-teal-700 transition-colors">
                <BookOpen className="h-5 w-5 text-teal-700" />
                <span className="font-display text-sm font-bold">ED Whiteboard</span>
            </Link>
            <div className="flex-1 flex justify-center">
                <SearchBar compact />
            </div>
            <Link
                to="/admin"
                data-testid="topbar-admin-link"
                className="hidden sm:inline-flex items-center gap-1.5 text-xs font-medium text-slate-600 hover:text-teal-700 transition-colors"
            >
                <Settings className="h-3.5 w-3.5" />
                Admin
            </Link>
        </header>
    );
}
